var _circle, _mask, _rect, _path, _mask2, _rect2, _path2, _mask3, _rect3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoardList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "transparent"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_38_778",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 8,
    height: 8,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#5D5B53",
    stroke: "#5D5B53",
    strokeWidth: 6,
    mask: "url(#path-2-inside-1_38_778)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 19.5H54C54.2761 19.5 54.5 19.7239 54.5 20V24C54.5 24.2761 54.2761 24.5 54 24.5H27C26.7239 24.5 26.5 24.2761 26.5 24V20C26.5 19.7239 26.7239 19.5 27 19.5Z",
    fill: "#5D5B53",
    stroke: "#5D5B53",
    strokeWidth: 3
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_38_778",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 31,
    width: 8,
    height: 8,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 31,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#5D5B53",
    stroke: "#5D5B53",
    strokeWidth: 6,
    mask: "url(#path-4-inside-2_38_778)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 32.5H54C54.2761 32.5 54.5 32.7239 54.5 33V37C54.5 37.2761 54.2761 37.5 54 37.5H27C26.7239 37.5 26.5 37.2761 26.5 37V33C26.5 32.7239 26.7239 32.5 27 32.5Z",
    fill: "#5D5B53",
    stroke: "#5D5B53",
    strokeWidth: 3
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_38_778",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 44,
    width: 8,
    height: 8,
    rx: 2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 44,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#5D5B53",
    stroke: "#5D5B53",
    strokeWidth: 6,
    mask: "url(#path-6-inside-3_38_778)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45.5H54C54.2761 45.5 54.5 45.7239 54.5 46V50C54.5 50.2761 54.2761 50.5 54 50.5H27C26.7239 50.5 26.5 50.2761 26.5 50V46C26.5 45.7239 26.7239 45.5 27 45.5Z",
    fill: "#5D5B53",
    stroke: "#5D5B53",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardList);
export default __webpack_public_path__ + "static/media/board_list.c3fc49c3a5d6a4643181bc873d6b80c9.svg";
export { ForwardRef as ReactComponent };